// routes.ts
import { Routes } from '@angular/router';
import { authGuard } from '@ibc-features/user/guards/auth.guard';
import { guestGuard } from '@ibc-features/user/guards/guest.guard';
import { LoginComponent } from '@ibc-features/user/login/login.component';
import { RecoverPasswordConfirmationComponent } from '@ibc-features/user/login/recover-password-confirmation/recover-password-confirmation.component';
import { RecoverPasswordFormComponent } from '@ibc-features/user/login/recover-password-form/recover-password-form.component';
import { PreregistrationComponent } from '@ibc-features/user/preregistration/preregistration.component';
import { ProfileComponent } from '@ibc-features/user/profile/profile.component';
import { RegisterConfirmationComponent } from '@ibc-features/user/register/register-confirmation/register-confirmation.component';
import { confirmAccountResolver } from '@ibc-features/user/register/register-confirmation/register-confirmation.resolver';
import { RegisterComponent } from '@ibc-features/user/register/register.component';
import { environment } from 'src/environments/environment.prod';

// Ajusta la ruta del import si usas alias distintos

const USER_ROUTES: Routes = [
  {
    path: 'user',
    children: [
      { path: '', redirectTo: '/', pathMatch: 'full' },
      { path: 'login', component: LoginComponent, canActivate: [guestGuard] },
      { path: 'create-account', component: RegisterComponent, canActivate: [guestGuard] },
      { path: 'profile', component: ProfileComponent, canActivate: [authGuard] },
      { path: 'registration', component: PreregistrationComponent, canActivate: [authGuard] },
      { path: 'profile', component: ProfileComponent, canActivate: [authGuard] },
      { path: 'reset-password', component: RecoverPasswordConfirmationComponent, canActivate: [guestGuard] },
      { path: 'confirm-password', component: RecoverPasswordFormComponent, canActivate: [guestGuard] },
      {
        path: 'confirm-email',
        component: RegisterConfirmationComponent,
        canActivate: [guestGuard],
        resolve: { ok: confirmAccountResolver },
      },
    ],
  },
];

const USER_ROUTES_DISABLED: Routes = [
  {
    path: 'user',
    children: [{ path: '**', redirectTo: '/', pathMatch: 'full' }],
  },
];

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () => import('@ibc-features/general/home/home.component').then(m => m.HomeComponent),
      },
      {
        path: 'maintenance',
        loadComponent: () => import('@ibc-features/fallback/maintenance/maintenance.component').then(m => m.MaintenanceComponent),
      },
      {
        path: '404',
        loadComponent: () => import('@ibc-features/fallback/not-found/not-found.component').then(m => m.NotFoundComponent),
      },
    ],
  },
  {
    path: '',
    children: [
      {
        path: 'volunteer',
        loadComponent: () => import('@ibc-features/general/volunteering/volunteering.component').then(m => m.VolunteeringComponent),
      },
      // {
      //   path: 'collaborators',
      //   loadComponent: () => import('@ibc-features/general/collaborators/collaborators.component').then(m => m.CollaboratorsComponent),
      // },
      {
        path: 'organization',
        loadComponent: () => import('@ibc-features/general/organization/organization.component').then(m => m.OrganizationComponent),
      },
      {
        path: 'faq',
        loadComponent: () => import('@ibc-features/general/faq/faq.component').then(m => m.FaqComponent),
      },
      {
        path: 'contact',
        loadComponent: () => import('@ibc-features/general/contact/contact.component').then(m => m.ContactComponent),
      },
      {
        path: 'status',
        loadComponent: () => import('@ibc-features/general/status/status.component').then(m => m.StatusComponent),
      },
      {
        path: 'badge',
        loadComponent: () => import('@ibc-features/badge/badge-view/badge-view.component').then(m => m.BadgeViewComponent),
        canActivate: [authGuard],
      },
      {
        path: 'badge/edit',
        loadComponent: () => import('@ibc-features/badge/manage-badge/manage-badge.component').then(m => m.ManageBadgeComponent),
        canActivate: [authGuard],
      },
    ],
  },
  {
    path: 'event',
    children: [
      { path: '', redirectTo: 'tickets', pathMatch: 'full' },
      // {
      //   path: 'activities',
      //   loadComponent: () => import('@ibc-features/event/activities/activities.component').then(m => m.ActivitiesComponent),
      // },
      {
        path: 'tickets',
        loadComponent: () => import('@ibc-features/event/tickets/tickets.component').then(m => m.TicketsComponent),
      },
      {
        path: 'hotel',
        loadComponent: () => import('@ibc-features/event/hotel/hotel.component').then(m => m.HotelComponent),
      },
      {
        path: 'dealers-den',
        loadComponent: () => import('@ibc-features/event/dealers/dealers.component').then(m => m.DealersComponent),
      },
      {
        path: 'artist-alley',
        loadComponent: () => import('@ibc-features/event/artist-alley/artist-alley.component').then(m => m.ArtistAlleyComponent),
      },
      {
        path: 'convention-center',
        loadComponent: () =>
          import('@ibc-features/event/convention-center/convention-center.component').then(m => m.ConventionCenterComponent),
      },
    ],
  },
  {
    path: 'policies',
    children: [
      { path: '', redirectTo: 'legal', pathMatch: 'full' },
      {
        path: 'legal',
        loadComponent: () => import('@ibc-features/policies/legal/legal.component').then(m => m.LegalComponent),
      },
      {
        path: 'cookies',
        loadComponent: () => import('@ibc-features/policies/cookies/cookies-policy.component').then(m => m.CookiesPolicyComponent),
      },
      {
        path: 'cookies-settings',
        loadComponent: () =>
          import('@ibc-shared/components/cookies/cookie-settings/cookie-settings.component').then(m => m.CookieSettingsComponent),
      },
      {
        path: 'privacy',
        loadComponent: () => import('./features/policies/privacy/privacy.component').then(m => m.PrivacyComponent),
      },
      // {
      //   path: 'rules',
      //   loadComponent: () => import('@ibc-features/policies/rules/rules.component').then(m => m.RulesComponent),
      // },
      {
        path: 'account',
        loadComponent: () => import('@ibc-features/policies/account-policy/account-policy.component').then(m => m.AccountPolicyComponent),
      },
      {
        path: 'tickets',
        loadComponent: () => import('@ibc-features/policies/tickets-policy/tickets-policy.component').then(m => m.TicketsPolicyComponent),
      },
    ],
  },

  ...(environment.disableUsers ? USER_ROUTES_DISABLED : USER_ROUTES),

  { path: '**', redirectTo: '404', pathMatch: 'full' },
];
